// SETTINGS — a modal panel of player preference toggles (persisted via
// game/settings.js). Add a row to TOGGLES + a DEFAULTS entry in settings.js to
// surface a new option; the systems that care read getSetting() directly.

import { Events, on, emit } from './eventBus.js'
import { makeModalToggleable } from './railPanel.js'
import { getSetting, setSetting } from '../game/settings.js'
import { ACCENTS } from '../game/accent.js'

const TOGGLES = [
  {
    key: 'nightMode',
    label: 'Night mode',
    desc: 'Day/night lighting that follows your local time — glowing lanterns, campfires & stars after dark.',
  },
  {
    key: 'buildingLabels',
    label: 'Building labels',
    desc: 'Hover a building to see its name and purpose (temple, school, hospital…).',
  },
]

export function mountSettingsPanel({ root }) {
  root.classList.add('hud__settings')
  root.innerHTML = `
    <div class="hud__build-header"><span class="hud__build-title">SETTINGS</span></div>
    <div class="set__list" data-set-list></div>
  `
  const list = root.querySelector('[data-set-list]')

  const accentRow = () => {
    const current = getSetting('accentColor')
    return `
      <div class="set__row set__row--stack">
        <span class="set__info">
          <span class="set__name">Accent color</span>
          <span class="set__desc">Tint the buttons, highlights & borders across the kingdom.</span>
        </span>
        <span class="set__swatches">
          ${ACCENTS.map((a) => `
            <button type="button" class="set__swatch ${a.key === current ? 'on' : ''}"
              data-accent="${a.key}" style="--sw:${a.base}" title="${a.label}" aria-label="${a.label}"></button>
          `).join('')}
        </span>
      </div>
    `
  }

  const controllerRow = () => `
    <div class="set__row">
      <span class="set__info">
        <span class="set__name">Controller</span>
        <span class="set__desc">Map your gamepad's buttons & sticks (works with any controller).</span>
      </span>
      <button type="button" class="hud__build-buy" data-controller-setup><span class="lbl">SET UP</span></button>
    </div>
  `

  const render = () => {
    list.innerHTML = TOGGLES.map((t) => `
      <label class="set__row">
        <span class="set__info">
          <span class="set__name">${t.label}</span>
          <span class="set__desc">${t.desc}</span>
        </span>
        <span class="set__switch ${getSetting(t.key) ? 'on' : ''}">
          <input type="checkbox" data-set="${t.key}" ${getSetting(t.key) ? 'checked' : ''} hidden>
          <span class="set__knob"></span>
        </span>
      </label>
    `).join('') + accentRow() + controllerRow()
  }
  render()

  // Delegated change handler survives the modal-card wrapping (events bubble up).
  root.addEventListener('change', (e) => {
    const cb = e.target.closest('[data-set]')
    if (!cb) return
    setSetting(cb.dataset.set, cb.checked)
    render()
  })

  // Controller-setup launcher.
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-controller-setup]')) {
      root.classList.remove('open')
      emit(Events.OpenControllerSetup)
    }
  })

  // Accent swatches are buttons, not checkboxes — handle their click.
  root.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-accent]')
    if (!sw) return
    setSetting('accentColor', sw.dataset.accent)
    render()
  })

  // No rail button — the modal is opened from the Registry/Profile header gear.
  makeModalToggleable(root, null)
  on(Events.OpenSettings, () => {
    document.querySelectorAll('[data-rail-panel]').forEach((p) => p.classList.remove('open'))
    root.classList.add('open')
  })
}
